import { Box, CircularProgress, Fade } from '@mui/material';

interface LoadingFallbackProps {
  minHeight?: string | number;
  backgroundColor?: string;
  showText?: boolean;
  text?: string;
}

const LoadingFallback = ({
  minHeight = 'calc(100vh - 80px)',
  backgroundColor = '#f6f9fb',
  showText = false,
  text = 'Loading...',
}: LoadingFallbackProps) => {
  return (
    <Fade in timeout={200}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight,
          backgroundColor,
          gap: 2,
        }}
        role="status"
        aria-live="polite"
        aria-label="Loading content"
      >
        <CircularProgress size={48} />
        {showText && (
          <Box
            sx={{
              color: 'text.secondary',
              fontSize: '0.875rem',
            }}
          >
            {text}
          </Box>
        )}
      </Box>
    </Fade>
  );
};

export default LoadingFallback;
